import { TRACK_IDS } from "../../../analytics/trackIds";
import React, { useEffect, useRef, useState } from "react";
import AudioOnIcon from "../../../assets/icons/svg/AudioOnlIcon";
import AudioOffIcon from "../../../assets/icons/svg/AudioOffIcon";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { setCookieApiCall } from "../../../api/config/configApi";
import localizationStrings from "../../../statics/localization";
import { isPlayerShortcut } from "./playerInteraction";

const clampVolume = (value) => Math.min(100, Math.max(0, value));
export default function AudioControl({ player }) {
  const [volume, setVolume] = useState(100);
  const previousVolume = useRef(100);
  const saveTimer = useRef(null);
  const changeVolume = (value) => {
    const next = clampVolume(value);
    if (next > 0) previousVolume.current = next;
    player.volume(next / 100);
    player.muted(next === 0);
    setVolume(next);
    localStorage.setItem("volume", String(next));
    clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => {
      Promise.resolve(setCookieApiCall("volume", next)).catch(() => {});
    }, 500);
  };
  useEffect(() => {
    if (!player) return;
    const saved = localStorage.getItem("volume");
    if (saved !== null && saved.trim() !== "" && Number.isFinite(Number(saved)))
      player.volume(clampVolume(Number(saved)) / 100);
    const sync = () => {
      const next = player.muted() ? 0 : Math.round(player.volume() * 100);
      if (next > 0) previousVolume.current = next;
      setVolume(next);
    };
    const onKey = (event) => {
      if (
        !isPlayerShortcut(event, player) ||
        (event.key !== "ArrowUp" && event.key !== "ArrowDown")
      )
        return;
      event.preventDefault();
      const current = player.muted() ? 0 : player.volume() * 100;
      changeVolume(current + (event.key === "ArrowUp" ? 10 : -10));
    };
    sync();
    player.on("volumechange", sync);
    document.addEventListener("keydown", onKey);
    return () => {
      clearTimeout(saveTimer.current);
      player.off("volumechange", sync);
      document.removeEventListener("keydown", onKey);
    };
  }, [player]);
  return (
    <div className="rc-slider-wrapper audio-slider">
      <button
        type="button"
        data-track-id={TRACK_IDS.PLAYER_AUDIO}
        className="control-button"
        title={
          volume
            ? localizationStrings.playerOptions.audioOff
            : localizationStrings.playerOptions.audioOn
        }
        onClick={() => changeVolume(volume ? 0 : previousVolume.current)}
      >
        {volume ? <AudioOnIcon /> : <AudioOffIcon />}
      </button>
      <Slider
        min={0}
        max={100}
        value={volume}
        ariaLabelForHandle={localizationStrings.volume || "Volume"}
        onChange={changeVolume}
      />
    </div>
  );
}
